export class CurrencyModel {
    public cod: string;
    public description: string;
    public rate: number;
}
